import { usePermissionsStore } from '@/modules/permissions/stores/permissionsStore'

/* Права проверяем до действия входа: модалка и страницы открываются раньше поиска якоря */
export const staffConditions: Record<string, () => boolean> = {
  'staff.canSettings': () => {
    const management = usePermissionsStore().modules.employee_management

    return Boolean(management?.department_edit || management?.position_edit)
  },
  'staff.canViewActivity': () => Boolean(usePermissionsStore().modules.employee_management?.employee_view),
  // Карточку открывает пункт «Редактировать» в меню строки — он есть только с этим правом
  'staff.canEditEmployee': () => Boolean(usePermissionsStore().modules.employee_management?.employee_edit),
  // Меню строки: «Посмотреть активность» — с employee_view, «Редактировать» и «Восстановить» — с employee_edit
  'staff.menuBasic': () => {
    const management = usePermissionsStore().modules.employee_management

    return !management?.employee_view && !management?.employee_edit
  },
  'staff.menuView': () => {
    const management = usePermissionsStore().modules.employee_management

    return Boolean(management?.employee_view && !management?.employee_edit)
  },
  'staff.menuEdit': () => {
    const management = usePermissionsStore().modules.employee_management

    return Boolean(!management?.employee_view && management?.employee_edit)
  },
  'staff.menuFull': () => {
    const management = usePermissionsStore().modules.employee_management

    return Boolean(management?.employee_view && management?.employee_edit)
  },
  'staff.cannotViewActivity': () => !usePermissionsStore().modules.employee_management?.employee_view,
}
